/* eslint-disable import/no-anonymous-default-export */
import axiosInstance from "../axios/axios-configuration";
import { CancelToken } from "axios";
import { IUor, IUser } from "../shared/interfaces";

const controller = 'Users';


const getUserInfo = (cancelToken?: CancelToken): Promise<IUser> => {
    return axiosInstance.get(`${controller}/GetUserInfo`, { cancelToken: cancelToken })
        .then(result => result.data)
        .catch(error => {
            return Promise.reject(error);
        });
}

//const getUserInfoInSelectedUor = (aooId: number, uorId: number, userId: string, cancelToken?: CancelToken): Promise<IUser> => {
//    return axiosInstance.get(`${controller}/${aooId}/${uorId}/GetUserInfoInSelectedUor`, { cancelToken: cancelToken, params: { UserId: userId } })
//        .then(result => result.data)
//        .catch(error => {
//            return Promise.reject(error);
//        });
//}

const getAllUsersInSelectedAoo = (aooId: number, cancelToken?: CancelToken): Promise<IUser[]> => {
    return axiosInstance.get(`${controller}/${aooId}/GetAllUsersInSelectedAoo`, { cancelToken: cancelToken })
        .then(result => result.data)
        .catch(error => {
            return Promise.reject(error);
        });
}

const getAllUsersInSelectedUor = (aooId: number, uorId: number, cancelToken?: CancelToken): Promise<IUser[]> => {
    return axiosInstance.get(`${controller}/${aooId}/${uorId}/GetAllUsersInSelectedUor`, { cancelToken: cancelToken })
        .then(result => result.data)
        .catch(error => {
            return Promise.reject(error);
        });
}

const getAllUsers = (cancelToken?: CancelToken): Promise<IUser[]> => {
    return axiosInstance.get(`${controller}/GetAllUsers`, { cancelToken: cancelToken })
        .then(result => result.data)
        .catch(error => {
            return Promise.reject(error);
        });
}

const getUserSuggestion = (text: string, cancelToken?: CancelToken): Promise<IUser[]> => {
    return axiosInstance.get(`${controller}/GetUserSuggestion/${text}`, { cancelToken: cancelToken })
        .then(result => result.data)
        .catch(error => {
            return Promise.reject(error);
        });
}


const addUser = (user: Partial<IUser>, cancelToken?: CancelToken): Promise<any> => {
    return axiosInstance.post(`${controller}/AddUser`, user, { cancelToken: cancelToken })
        .then(result => result.data)
        .catch(error => {
            return Promise.reject(error);
        });
}

const updateUser = (user: Partial<IUser>, cancelToken?: CancelToken): Promise<any> => {
    return axiosInstance.post(`${controller}/UpdateUser`, user, { cancelToken: cancelToken })
        .then(result => result.data)
        .catch(error => {
            return Promise.reject(error);
        });
}

const updateUserInAoo = (aooId: number, user: Partial<IUser>, cancelToken?: CancelToken): Promise<any> => {
    return axiosInstance.post(`${controller}/${aooId}/UpdateUserInAoo`, user, { cancelToken: cancelToken })
        .then(result => result.data)
        .catch(error => {
            return Promise.reject(error);
        });
}

const deleteUser = (user: Partial<IUser>, cancelToken?: CancelToken): Promise<any> => {
    return axiosInstance.post(`${controller}/DeleteUser`, user, { cancelToken: cancelToken })
        .then(result => result.data)
        .catch(error => {
            return Promise.reject(error);
        });
}



const userHasAnyUorContextRoleInSelectedUor = (user: Partial<IUser>, uorId: number): boolean => {
    return user.ruoliUorContext
        ? user.ruoliUorContext?.some((el) => el.uorId === uorId)
        : false;
}

const userIsAdmin = (user: Partial<IUser>, aooId: number): boolean => {
    return user.ruoliAooContext
        ? user.ruoliAooContext.some((el) => el.aooId === aooId && el.ruolo?.nome === "Admin")
        : false;
}

const userIsSupervisore = (user: Partial<IUser>, aooId: number): boolean => {
    return user.ruoliAooContext
        ? user.ruoliAooContext?.some((el) => el.aooId === aooId && el.ruolo?.nome === "Supervisore")
        : false;
}

function userHasAnyAooContextRoleInSelectedAoo(user: Partial<IUser>, aooId: number): boolean {
    return user.ruoliAooContext
        ? user.ruoliAooContext?.some((el) => el.aooId === aooId)
        : false;
}


export default {
    getUserInfo,
    //getUserInfoInSelectedUor,
    getAllUsersInSelectedUor,
    getAllUsersInSelectedAoo,
    getAllUsers,
    getUserSuggestion,
    addUser,
    updateUser,
    updateUserInAoo,
    deleteUser,
    userHasAnyUorContextRoleInSelectedUor,
    userIsAdmin,
    userIsSupervisore,
    userHasAnyAooContextRoleInSelectedAoo
}